module.exports = __webpack_public_path__ + "static/media/OverlappedCard.83a9cccb.svg";